import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { ADD_ORG_DATA } from 'actions/actionTypes';
import { useDispatch } from 'react-redux';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getOrganization } from 'services/admin';

export const useOrganizationSettings = (organizationId: number) => {
  const dispatch = useDispatch();
  const { data, isLoading, isFetching, ...rest } = useQuery({
    queryKey: [REACT_QUERY_KEYS.settings.OrganizationSettings, organizationId],
    queryFn: () => getOrganization(organizationId),
    refetchInterval: 1000 * 60 * 60, // 1 hour
    enabled: !!organizationId,
  });

  useEffect(() => {
    if (!isLoading || !isFetching) {
      dispatch({
        type: ADD_ORG_DATA,
        data: {
          ...data,
          organizationTimezone: data?.timezone,
        },
      });
    }
  }, [data, isLoading, isFetching, dispatch]);

  return {
    data,
    isLoading,
    isFetching,
    ...rest,
  };
};
